module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Oberlunkhofen_AG-00959b92fae6e9a64f09f1ae7414c49e.svg";